import { Loadable } from '@interfaces/helpers';
import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { GameCharacter } from '@interfaces/game';
import GameService from "@api/user/gameService";
import FetchResult from "@models/fetchResult";

const slice = createSlice({
    initialState: {
        loaded: false,
        loading: false,
        error: null,
        data: []
    } as Loadable<GameCharacter[]>,
    name: 'userCharactersStore',
    reducers: {
        setLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        setError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        setCharacters: (state, action: PayloadAction<GameCharacter[]>) => {
            state.data = action.payload;
            state.loaded = true;
            state.loading = false;
            state.error = null;
        }
    }
});

const {
    setCharacters,
    setError,
    setLoading
} = slice.actions;

export const { reducer: userCharactersReducer } = slice;

export const characterActions = {
    loadCharacters: () => async (dispatch: Dispatch) => {
        dispatch(setLoading());
        try {
            const api = new GameService();
            const result = await api.fetchCharacters();
            if(result.ok) {
                dispatch(setCharacters(result.data));
            }
            else {
                dispatch(setError(result));
            }
            return result;
        }
        catch(e) {
            dispatch(setError(e));
            return e as FetchResult<GameCharacter[]>;
        }
    },
    setCharacters
}